import styled, { css } from 'styled-components';

export const ClaimRewardsToggleStyled = styled.div.attrs({
  className: 'claim-rewards-toggle',
})`
  ${() => {
    return css`
      display: flex;
      align-items: center;
      gap: 0.5rem;
    `;
  }};
`;
